const spdata2023 = [
  {
    Name: "Aalap gopesh sanghvi",
    Roll: "18BEC001",
    Personal: "sanghviaalap24@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aalap-sanghvi/",
    Company: "DevX",
  },
  {
    Name: "Hardikkumar dineshbhai chaudhary",
    Roll: "18BEC018",
    Personal: "hardikchaudhary9750@gmail.com",
    Linkedin: "https://www.linkedin.com/in/hardik-chaudhary-79240a183/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Parmar yamankumar virendra",
    Roll: "18BEC070",
    Personal: "yamanvparmar@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yaman-parmar-a9ba3b193",
    Company: "Photonics Watertech Pvt. Ltd.",
  },
  {
    Name: "Patel rutvikkumar popatbhai ",
    Roll: "18BEC074",
    Personal: "rutvikpatelofficial07@gmail.com",
    Linkedin: "https://www.linkedin.com/in/rutvik-patel-27444b168",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Shrey rakesh jain",
    Roll: "18BEC103",
    Personal: "shrey.jain56@gmail.com",
    Linkedin: "http://linkedin.com/in/shrey-j-758568137",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Tandel daksh g",
    Roll: "18BEC113",
    Personal: "daxtandel88888@gmail.com",
    Linkedin:"/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Aakarshak suresh nandwani",
    Roll: "19BEC001",
    Personal: "aakarshak8@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aakarshak-nandwani-877424190/",
    Company: "E-Infochip",
  },
  {
    Name: "Aanchal ajit tiwary",
    Roll: "19BEC002",
    Personal: "tiwariaanchal0@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aanchal-tiwary-51a2b61a5",
    Company: "Ecubix",
  },
  {
    Name: "Adish golechha",
    Roll: "19BEC003",
    Personal: "adish.golechha@gmail.com",
    Linkedin: "https://www.linkedin.com/in/adish-golechha/",
    Company: "Central Group",
  },
  {
    Name: "Aditya r",
    Roll: "19BEC004",
    Personal: "radityak2001@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aditya-rk01",
    Company: "E-Infochip",
  },
  {
    Name: "Shyam sureshbhai aghara",
    Roll: "19BEC005",
    Personal: "samoaghara@gmail.com",
    Linkedin: "www.linkedin.com/in/shyam-aghara-2b0728236",
    Company: "SunBond Energy Pvt. Ltd.",
  },
  {
    Name: "Harsh hitendra ahuja",
    Roll: "19BEC006",
    Personal: "ahujaharsh20@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harsh-ahuja-b32a7a1a0",
    Company: "E-Infochip",
  },
  {
    Name: "Akshat jain",
    Roll: "19BEC007",
    Personal: "akshatmjain1999@gmail.com",
    Linkedin: "www.linkedin.com/in/akshat-jain-921438191",
    Company: "E-Infochip",
  },
  {
    Name: "Akshat baheti",
    Roll: "19BEC008",
    Personal: "akbaheti157@gmail.com",
    Linkedin: "https://www.linkedin.com/in/akb157/",
    Company: "National High Speed Rail Corporation Limited (NHSRCL)",
  },
  {
    Name: "Akshat rajesh muke",
    Roll: "19BEC009",
    Personal: "akshatmuke3101@nirmauni.ac.in",
    Linkedin: "www.linkedin.com/in/akshat-muke",
    Company: "West Central Railway, Bhopal Division",
  },
  {
    Name: "Harsh nareshbhai anand",
    Roll: "19BEC010",
    Personal: "anandharsh291@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harsh-anand-59a738192/",
    Company: "Aavolate Technologies Pvt. Ltd.",
  },
  {
    Name: "Aum devang jasani",
    Roll: "19BEC011",
    Personal: "jasaniaum@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aumjasani/",
    Company: "Nhance Dynamics",
  },
  {
    Name: "Avi shekhar nawal",
    Roll: "19BEC012",
    Personal: "avisnawal@gmail.com",
    Linkedin: "linkedin.com/in/avi-nawal-697290204",
    Company: "E-Infochip",
  },
  {
    Name: "Aviral singhal",
    Roll: "19BEC013",
    Personal: "aviral.singhal.nirma.uni@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aviral786/",
    Company: "Oizom",
  },
  {
    Name: "Ayush tiwari",
    Roll: "19BEC014",
    Personal: "ayushhtiwaari@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ayush-tiwari-636853190",
    Company: "KANSOFT SOLUTIONS PVT. LTD.",
  },
  {
    Name: "Ayushi jain",
    Roll: "19BEC015",
    Personal: "ayushijain61202@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ayushi-j-215877203/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Niravkumar kantilal bhanderi",
    Roll: "19BEC016",
    Personal: "niravbhanderi1972@gmail.com",
    Linkedin: "www.linkedin.com/in/nirav-bhanderi-844164190",
    Company: "E-Infochip",
  },
  {
    Name: "Nisha suresh chaudhary",
    Roll: "19BEC017",
    Personal: "nishabeniwal9033@gmail.com",
    Linkedin: "linkedin.com/in/n.com/in/nisha-c-6444a4214",
    Company: "E-Infochip",
  },
  {
    Name: "Chaitanya rajesh chhichhia",
    Roll: "19BEC018",
    Personal: "chaitanya27111@gmail.com",
    Linkedin: "https://www.linkedin.com/in/chaitanya-chhichhia-48033a19a/",
    Company: "E-Infochip",
  },
  {
    Name: "Harshil dineshbhai dabhoya ",
    Roll: "19BEC020",
    Personal: "harshil123dabhoya@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harshil-dabhoya-a922a0211",
    Company: "E-Infochip",
  },
  {
    Name: "Aman vinod daryani",
    Roll: "19BEC021",
    Personal: "amandaryani0510@gmail.com",
    Linkedin: "http://linkedin.com/in/aman-daryani-882033230",
    Company: "E-Infochip",
  },
  {
    Name: "Barun bablu debnath",
    Roll: "19BEC022",
    Personal: "barundebnath91@gmail.com",
    Linkedin: "https://linkedin.com/in/barundebnath",
    Company: "EOL - Viable recommerce India Pvt Ltd-Ahmedabad",
  },
  {
    Name: "Deep mukesh krishnani",
    Roll: "19BEC023",
    Personal: "dipdip1532@gmail.com",
    Linkedin: "https://www.linkedin.com/in/deep-k-3371b51b5",
    Company: "Reliance Jio Infocomm Ltd.",
  },
  {
    Name: "Dev ashish patwa ",
    Roll: "19BEC024",
    Personal: "devpatwa.2001@gmail.com",
    Linkedin: "https://www.linkedin.com/in/devpatwa",
    Company: "CSE Solutions",
  },
  {
    Name: "Shivangi miteshkumar dhamecha",
    Roll: "19BEC025",
    Personal: "dhamechashivangi0@gmail.com",
    Linkedin: "http://www.linkedin.com/in/shivangi-dhamecha-7965ba218",
    Company: "E-Infochip",
  },
  {
    Name: "Dhruv sunil parmar",
    Roll: "19BEC026",
    Personal: "dhruv.p8601@gmail.com",
    Linkedin: "linkedin.com/in/ddhruv64/",
    Company: "LoveMySkool (Amor Inventions Pvt. Ltd.)",
  },
  {
    Name: "Dhruvit chinmay tripathi",
    Roll: "19BEC027",
    Personal: "dhruvittripathi@gmail.com",
    Linkedin: "www.linkedin.com/in/dhruvit-tripathi-128338209",
    Company: "E-Infochip",
  },
  {
    Name: "Dhvanil chauhan",
    Roll: "19BEC028",
    Personal: "dhvanilchauhanp@gmail.com",
    Linkedin: "http://www.linkedin.com/in/dhvanil-chauhan-45b473233",
    Company: "PGP Glass Pvt Ltd",
  },
  {
    Name: "Digvijaysinh sandeepsinh chudasama",
    Roll: "19BEC029",
    Personal: "digvijaychudasama27@gmail.com",
    Linkedin: "https://www.linkedin.com/in/digvijaysinh-chudasama27/",
    Company: "E-Infochip",
  },
  {
    Name: "Dev nileshbhai diwan",
    Roll: "19BEC030",
    Personal: "diwandev07@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dev-diwan-24d",
    Company: "E-Infochip",
  },
  {
    Name: "Dhairya sunilkumar dutt",
    Roll: "19BEC031",
    Personal: "dhairyadutt2002@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhairya-dutt-707a3b1b2/",
    Company: "E-Infochip",
  },
  {
    Name: "Henil hirenkumar gajjar",
    Roll: "19BEC032",
    Personal: "henilgajjar08@gmail.com",
    Linkedin: "https://www.linkedin.com/in/henil-gajjar-a43a78187/",
    Company: "StudioCarbon",
  },
  {
    Name: "Rutul miteshbhai gandhi",
    Roll: "19BEC033",
    Personal: "rutulgandhi43@gmail.com",
    Linkedin: "https://www.linkedin.com/in/rutul-gandhi-b309aa191/",
    Company: "E-Infochip",
  },
  {
    Name: "Gaurang maheshwari",
    Roll: "19BEC034",
    Personal: "gaurang.ibd@gmail.com",
    Linkedin: "https://www.linkedin.com/in/gaurang-maheshwari-6153881b8/",
    Company: "E-Infochip",
  },
  {
    Name: "Anish rajesh gupta",
    Roll: "19BEC035",
    Personal: "anishgupta2610@gmail.com",
    Linkedin: "https://www.linkedin.com/in/anish-gupta-a28a20191",
    Company: "D360",
  },
  {
    Name: "Harsheet maliwal",
    Roll: "19BEC036",
    Personal: "harsheet0003@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harsheet-maliwal-22a8961b3/",
    Company: "StudioCarbon",
  },
  {
    Name: "Heli patel",
    Roll: "19BEC037",
    Personal: "heli18patel@gmail.com",
    Linkedin: "https://www.linkedin.com/in/heli-patel-066a05241",
    Company: "Atul Ltd",
  },
  {
    Name: "Shaily nirajbhai hirani ",
    Roll: "19BEC038",
    Personal: "shailyhirani9@gmail.com ",
    Linkedin: "https://www.linkedin.com/in/shaily-hirani-598768191/",
    Company: "Lnx Cloud Technology",
  },
  {
    Name: "Hitarth ashish patel",
    Roll: "19BEC039",
    Personal: "patelhitarth001@gmail.com",
    Linkedin: "https://www.linkedin.com/in/hitarth-patel-2b77241a7",
    Company: "Plutus Technologies Pvt. Ltd.",
  },
  {
    Name: "Indraganti vishnudatta",
    Roll: "19BEC040",
    Personal: "issvishnu@gmail.com",
    Linkedin: "https://www.linkedin.com/in/indraganti-vishnudatta-04b0b61b1/",
    Company: "Krossmark Innovations",
  },
  {
    Name: "Ishika suresh agarwal",
    Roll: "19BEC041",
    Personal: "ishikaagarwal886@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ishika-agarwal-b7487820b/",
    Company: "Kaiyo",
  },
  {
    Name: "Ishika lalit saijwal",
    Roll: "19BEC042",
    Personal: "ishikasaijwal.nirma@gmail.com",
    Linkedin: "www.linkedin.com/in/ishika-saijwal",
    Company: "Ottonomy io",
  },
  {
    Name: "Tilak jigar jagani",
    Roll: "19BEC043",
    Personal: "tilakjagani1511@gmail.com",
    Linkedin: "https://www.linkedin.com/in/tilak-jagani-9bb31b1aa",
    Company: "E-Infochip",
  },
  {
    Name: "Parth ashwin jain",
    Roll: "19BEC044",
    Personal: "jainparth0806@gmail.com",
    Linkedin: "https://www.linkedin.com/in/parth-jain-0804/",
    Company: "Tamanna Solutions Pvt. Ltd.",
  },
  {
    Name: "Jaineel modi",
    Roll: "19BEC045",
    Personal: "modijaineel@gmail.com",
    Linkedin: "https://www.linkedin.com/in/jaineel-modi-a52461114",
    Company: "E-Infochip",
  },
  {
    Name: "Jatin sangai",
    Roll: "19BEC046",
    Personal: "jatinsangai14120022@gmail.com",
    Linkedin: "https://www.linkedin.com/in/jatin-sangai-ba38471b2/",
    Company: "Spark to idea",
  },
  {
    Name: "Lalit anil jetwani",
    Roll: "19BEC047",
    Personal: "lalitjetwani2001@gmail.com",
    Linkedin: "linkedin.com/in/lalit-jetwani",
    Company: "Redicine Medsol",
  },
  {
    Name: "Jugal patel",
    Roll: "19BEC048",
    Personal: "jugalpatel753@gmail.com",
    Linkedin: "www.linkedin.com/in/jugal-patel-7b61b61b3",
    Company: "E-Infochip",
  },
  {
    Name: "Dhairya jaydeepbhai kachhy",
    Roll: "19BEC049",
    Personal: "dhairyakachhy2002@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhairya-kachhy-709300199/",
    Company: "Axisray",
  },
  {
    Name: "Keyuri jasminkumar kariya",
    Roll: "19BEC051",
    Personal: "k.kariyaa68@gmail.com",
    Linkedin: "https://www.linkedin.com/in/keyuri-kariya-a274371a8",
    Company: "E-Infochip",
  },
  {
    Name: "Kartikey mishra",
    Roll: "19BEC052",
    Personal: "k.kartikeymishra2017@gmail.com",
    Linkedin: "https://www.linkedin.com/in/kartikey-mishra-66817a194/",
    Company: "E-Infochip",
  },
  {
    Name: "Ketul rajesh mehta",
    Roll: "19BEC053",
    Personal: "k2.mehta412@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ketul-mehta-ab6b6120a",
    Company: "Cyphware Infotech Pvt. Ltd.",
  },
  {
    Name: "Sneh bhagwandas kriplani",
    Roll: "19BEC055",
    Personal: "snehkriplani@gmail.com",
    Linkedin: "linkedin.com/in/sneh-kriplani-b198741bb",
    Company: "Code Theorem",
  },
  {
    Name: "Kshiteej kosambia",
    Roll: "19BEC056",
    Personal: "kshiteej454@gmail.com",
    Linkedin: "https://www.linkedin.com/in/kshiteej-kosambia-239b75214/",
    Company: "Ducchas Global",
  },
  {
    Name: "Krupa govindbhai lakhani",
    Roll: "19BEC057",
    Personal: "lakhanikrupa616@gmail.com",
    Linkedin: "linkedin.com/in/krupa-lakhani-923298206",
    Company: "Jekson Vision",
  },
  {
    Name: "Maharsh nirajkumar khamar",
    Roll: "19BEC059",
    Personal: "kmaharsh1410@gmail.com",
    Linkedin: "https://www.linkedin.com/in/maharsh-khamar-a842271a4/",
    Company: "Adani Solar",
  },
  {
    Name: "Aditya neilprakash makwana",
    Roll: "19BEC060",
    Personal: "aditya.neil.makwana@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aditya-makwana-193315192/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Khushali sarvil makwana",
    Roll: "19BEC061",
    Personal: "KHUSHU1741@GMAIL.COM",
    Linkedin: "https://www.linkedin.com/in/khushalimakwana/",
    Company: "Cast and Alloys",
  },
  {
    Name: "Makwana purvesh",
    Roll: "19BEC062",
    Personal: "19bec062@nirmauni.ac.in",
    Linkedin: "zlhg3ticjys3",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Ravi makwana",
    Roll: "19BEC063",
    Personal: "19bec063@nirmauni.ac.in",
    Linkedin: "https://www.linkedin.com/in/ravi-makwana-62b2bb204",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Nimit shaileshbhai malani",
    Roll: "19BEC064",
    Personal: "malaninimit@gmail.com",
    Linkedin:
      "https://www.linkedin.com/in/nimit-malani-b42888191?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BzSDY3FeGRGSt%2FXPt%2FyuJ7A%3D%3D",
    Company: "Arvind Ltd",
  },
  {
    Name: "Malek fiza arifbhai",
    Roll: "19BEC065",
    Personal: "fizamalek711@gmail.com",
    Linkedin: "https://www.linkedin.com/in/fiza-malek-979a9b1aa",
    Company: "Bisag",
  },
  {
    Name: "Manasi yadav",
    Roll: "19BEC067",
    Personal: "manasi.yadav829@gmail.com",
    Linkedin: "https://www.linkedin.com/in/manasiyadav/",
    Company: "Indian Navy - INS Valsura",
  },
  {
    Name: "Darsh hiren maniar",
    Roll: "19BEC069",
    Personal: "dhmaniar01@gmail.com",
    Linkedin: "https://www.linkedin.com/in/darsh-maniar-368246201/",
    Company: "L&T Technology Services (LTTS)",
  },
  {
    Name: "Mann mehta",
    Roll: "19BEC070",
    Personal: "mannmehta3826@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mann-mehta-854513190/",
    Company: "E-Infochip",
  },
  {
    Name: "Shyam ashvinhai manvar",
    Roll: "19BEC071",
    Personal: "shyammanvar256@gmail.com",
    Linkedin: "www.linkedin.com/in/shyam-manvar-019331218",
    Company: "SunBond Energy Pvt. Ltd.",
  },
  {
    Name: "Mihir rana",
    Roll: "19BEC072",
    Personal: "mihirrana620@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mihir-rana-17909b119/",
    Company: "E-Infochip",
  },
  {
    Name: "Mohit agarwal k",
    Roll: "19BEC073",
    Personal: "mohitagarwal455@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mohit-agarwal-k/",
    Company: "Oizom",
  },
  {
    Name: "Mukesh kishanlal rangwani",
    Roll: "19BEC074",
    Personal: "rangwanimukesh24@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mukesh-rangwani-a5a3341b7/",
    Company: "D360",
  },
  {
    Name: "Nakrani himanshu ashvinbhai",
    Roll: "19BEC075",
    Personal: "himanshunakrani0@gmail.com",
    Linkedin: "https://www.linkedin.com/in/himanshu-nakrani",
    Company: "Green Field Control System",
  },
  {
    Name: "Naman deo",
    Roll: "19BEC076",
    Personal: "naman.deo.nd.149@gmail.com",
    Linkedin: "https://www.linkedin.com/in/namandeo/",
    Company: "Jekson Vision",
  },
  {
    Name: "Nikhil vinay gupta",
    Roll: "19BEC078",
    Personal: "nikhilg2804@gmail.com",
    Linkedin: "www.linkedin.com/in/nikhil-gupta-0172a11a3",
    Company: "E-Infochip",
  },
  {
    Name: "Nikshan pandita",
    Roll: "19BEC079",
    Personal: "nikshanpandita20@icloud.com",
    Linkedin: "/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Anushree hemanshu pachegaokar",
    Roll: "19BEC080",
    Personal: "anupachegaokar@gmail.com",
    Linkedin: "www.linkedin.com/in/anushreepachegaokar",
    Company: "E-Infochip",
  },
  {
    Name: "Palak jain",
    Roll: "19BEC081",
    Personal: "palakjain0927@gmail.com",
    Linkedin: "https://www.linkedin.com/public-profile/settings",
    Company: "Bharti Airtel",
  },
  {
    Name: "Pallavi kumari sharma",
    Roll: "19BEC082",
    Personal: "pallaviisharma0609@gmail.com",
    Linkedin: "https://www.linkedin.com/in/pallavi-sharma-22a7351a3",
    Company: "E-Infochip",
  },
  {
    Name: "Harsh ramesh panara",
    Roll: "19BEC083",
    Personal: "harshpanara22@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harsh-panara",
    Company: "BEMRR",
  },
  {
    Name: "Aastha sanjay panchal",
    Roll: "19BEC084",
    Personal: "panchalaastha@gmail.com",
    Linkedin: "linkedin.com/in/aastha-panchal-259017235",
    Company: "E-Infochip",
  },
  {
    Name: "Divyam hasitkumar pandya",
    Roll: "19BEC085",
    Personal: "divyampandya26@gmail.com",
    Linkedin: "linkedin.com/in/divyam-pandya-351681223",
    Company: "E-Infochip",
  },
  {
    Name: "Tanmay kamal parekh",
    Roll: "19BEC086",
    Personal: "tanmayparekh20@gmail.com",
    Linkedin: "linkedin.com/in/tanmay-parekh-0306",
    Company: "Oxvi",
  },
  {
    Name: "Aakash upendrabhai parmar",
    Roll: "19BEC087",
    Personal: "parmaraakash2353@gmail.com",
    Linkedin: "https://www.linkedin.com/in/parmar-aakash-102a75192/",
    Company: "E-Infochip",
  },
  {
    Name: "Chinmay kiransinh parmar ",
    Roll: "19BEC088",
    Personal: "parmarchinmay400@gmail.com",
    Linkedin: "www.linkedin.com/in/chinmay-parmar",
    Company: "Green Field Control System",
  },
  {
    Name: "Raj natvar parmar",
    Roll: "19BEC089",
    Personal: "rajparmar9106852538@gmail.xom",
    Linkedin: "https://www.linkedin.com/in/rajnparmar/",
    Company: "SaturnCube Technologies",
  },
  {
    Name: "Yuvrajsinh lalsinh parmar",
    Roll: "19BEC090",
    Personal: "yuvrajsinhthakor100@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yuvrajsinh-parmar/",
    Company: "Green Field Control System",
  },
  {
    Name: "Aatman harshit patel ",
    Roll: "19BEC091",
    Personal: "aatmanpatel2@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aatmanp4/",
    Company: "Oxvi",
  },
  {
    Name: "Darshit pradipkumar patel",
    Roll: "19BEC092",
    Personal: "kano02764@gmail.com",
    Linkedin: "linkedin.com/in/patel-darshit-23a326233",
    Company: "Dazzle Robotics",
  },
  {
    Name: "Het sunilkumar patel",
    Roll: "19BEC093",
    Personal: "het4902@gmail.com",
    Linkedin: "https://www.linkedin.com/in/het-patel-530653200/",
    Company: "Oizom",
  },
  {
    Name: "Hetvi ashishbhai patel",
    Roll: "19BEC094",
    Personal: "hetviapatel2142@gmail.com",
    Linkedin: "www.linkedin.com/in/hetvi-patel-6b0858207",
    Company: "E-Infochip",
  },
  {
    Name: "Patel jainil suhagkumar",
    Roll: "19BEC095",
    Personal: "jainilpatel2211@nirmauni.ac.in",
    Linkedin: "https://www.linkedin.com/in/patel-jainil-3228a4241/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Neel umesh patel",
    Roll: "19BEC096",
    Personal: "neelpatel.itnu@gmail.com",
    Linkedin: "www.linkedin.com/in/neel-p-178028194",
    Company: "VASU AUTOMATION AND ELECTRICALS",
  },
  {
    Name: "Parikshit rashmikant patel",
    Roll: "19BEC097",
    Personal: "patel1610parikshit3041@gmail.com",
    Linkedin: "https://www.linkedin.com/in/parikshit-patel-41b6551a4/",
    Company: "E-Infochip",
  },
  {
    Name: "Smit rajeshkumar patel",
    Roll: "19BEC098",
    Personal: "patel.smit3131@gmail.com",
    Linkedin: "https://www.linkedin.com/in/smit-patel-7688961ab/",
    Company: "Oizom",
  },
  {
    Name: "Patel sneh dushyantkumar",
    Roll: "19BEC099",
    Personal: "snehpatel7801@gmail.com",
    Linkedin: "https://www.linkedin.com/in/sneh-patel-0951a3208",
    Company: "E-Infochip",
  },
  {
    Name: "Vraj bhaveshkumar patel",
    Roll: "19BEC100",
    Personal: "vraj14082001@gmail.com",
    Linkedin: "https://www.linkedin.com/in/vrajpatel001/",
    Company: "E-Infochip",
  },
  {
    Name: "Pranjal singh",
    Roll: "19BEC101",
    Personal: "pranjals350@gmail.com",
    Linkedin: "linkedin.com/in/pranjal-singh-59150a1b6",
    Company: "Jenex Technologies",
  },
  {
    Name: "Prince bansal",
    Roll: "19BEC102",
    Personal: "p4princebansal@gmail.com",
    Linkedin: "https://www.linkedin.com/in/prince-bansal-p4",
    Company: "Krossmark Innovations",
  },
  {
    Name: "Maheevatsa abhaykumar rai",
    Roll: "19BEC103",
    Personal: "raimaheevatsa@gmail.com",
    Linkedin: "www.linkedin.com/in/maheevatsa-rai",
    Company: "Altenmo Technologies Pvt. Ltd.",
  },
  {
    Name: "Krish amitkumar rathod",
    Roll: "19BEC105",
    Personal: "krishrathod91011@gmail.com",
    Linkedin: 'https://www.linkedin.com/in/krish-rathod-a36763267/',
    Company: "Dazzle Robotics",
  },
  {
    Name: "Pallav rathod",
    Roll: "19BEC106",
    Personal: "rathodpallav456@gmail.com",
    Linkedin: "https://www.linkedin.com/in/pallav-rathod/",
    Company: "E-Infochip",
  },
  {
    Name: "Ratnesh mehta",
    Roll: "19BEC107",
    Personal: "ratneshmehta240943@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ratnesh-mehta-563630217/",
    Company: "Eship Simplified",
  },
  {
    Name: "Jainil jigeshbhai raval",
    Roll: "19BEC108",
    Personal: "jainilraval02@gmail.com",
    Linkedin: "https://www.linkedin.com/in/jainil-raval/",
    Company: "E-Infochip",
  },
  {
    Name: "Mann marlesh raval",
    Roll: "19BEC109",
    Personal: "mannraval1@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mann-raval-95360b103/",
    Company: "CSE Solutions",
  },
  {
    Name: "Rhydham kamleshbhai prajapati",
    Roll: "19BEC110",
    Personal: "rhydhamprajapati1421@gmail.com",
    Linkedin: "Rhydham Prajapati",
    Company: "NIFA Electronics pvt. Ltd.",
  },
  {
    Name: "Rinkal jain",
    Roll: "19BEC111",
    Personal: "jainrinkal116@gmail.com",
    Linkedin: "linkedin.com/in/rinkal-jain-b028061b7",
    Company: "Jekson Vision",
  },
  {
    Name: "Rishi agrawal",
    Roll: "19BEC112",
    Personal: "rishiagrawal0405@gmail.com",
    Linkedin: "http://www.linkedin.com/in/rishi-agrawal0405",
    Company: "Spark to idea",
  },
  {
    Name: "Rishita devendra chaliawala",
    Roll: "19BEC113",
    Personal: "rishita.802.chaliawala@gmail.com",
    Linkedin: "https://www.linkedin.com/in/rishitachaliawala",
    Company: "Embee Group",
  },
  {
    Name: "Rythem manish mehta",
    Roll: "19BEC114",
    Personal: "rythemmehtaa@gmail.com",
    Linkedin: "https://www.linkedin.com/in/rythem-mehta-7457111a7/",
    Company: "Jekson Vision",
  },
  {
    Name: "Vedang himanshu sadhu",
    Roll: "19BEC115",
    Personal: "vedangsadhu@gmail.com",
    Linkedin: "https://www.linkedin.com/in/vedang-sadhu-12853822a",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Rajiv ajay sadriwala",
    Roll: "19BEC116",
    Personal: "rajivsadriwala752001@gmail.com",
    Linkedin: "rajivsadriwala",
    Company: "Jekson Vision",
  },
  {
    Name: "Maarjani heman sanghavi",
    Roll: "19BEC117",
    Personal: "maarjani23s@gmail.com",
    Linkedin: "http://linkedin.com/in/maarjani-sanghavi-a73b78218",
    Company: "Krossmark Innovations",
  },
  {
    Name: "Sanghavi naitik kamlesh",
    Roll: "19BEC118",
    Personal: "naitiksanghavi6@gmail.com",
    Linkedin: "https://www.linkedin.com/in/naitik-sanghavi-433705205/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Abhay vijeshbhai shah",
    Roll: "19BEC119",
    Personal: "abhayshah00007@gmail.com",
    Linkedin: "https://www.linkedin.com/in/abhay-shah07/",
    Company: "Altenmo Technologies Pvt. Ltd.",
  },
  {
    Name: "Khush jayant shah",
    Roll: "19BEC120",
    Personal: "khushshahj@gmail.com",
    Linkedin: "https://www.linkedin.com/in/shah-khush-903b80205/",
    Company: "Adani Group",
  },
  {
    Name: "Mitul pritesh shah",
    Roll: "19BEC121",
    Personal: "shahmitul0005@gmail.com",
    Linkedin:
      "https://www.linkedin.com/in/mitul-shah-94b549190/?original_referer=",
    Company: "E-Infochip",
  },
  {
    Name: "Pratham hiteshkumar shah",
    Roll: "19BEC122",
    Personal: "shah.pratham235@gmail.com",
    Linkedin: "www.linkedin.com/in/pratham-shah-78359121b",
    Company: "Krossmark Innovations",
  },
  {
    Name: "Rushi paresh shah",
    Roll: "19BEC123",
    Personal: "rpshah274@gmail.com",
    Linkedin: "RUSHI SHAH",
    Company: "E-Infochip",
  },
  {
    Name: "Shivaditya chhaparwal",
    Roll: "19BEC124",
    Personal: "chhaparwalshivaditya@gmail.com",
    Linkedin: "https://www.linkedin.com/in/shivadityachhaparwal/",
    Company: "Kgs Fintech Private Limited",
  },
  {
    Name: "Pruthvirajsinh mahendrasinh solanki",
    Roll: "19BEC126",
    Personal: "pruthvirajmsolanki@gmail.com",
    Linkedin: "https://www.linkedin.com/in/pruthvirajsinh-solanki-8381351a8/",
    Company: "E-Infochip",
  },
  {
    Name: "Sparsh palkhiwala",
    Roll: "19BEC127",
    Personal: "palkhiwalasparsh2301@gmail.com",
    Linkedin: "https://www.linkedin.com/in/sparsh-palkhiwala-714ab6217/",
    Company: "Oxvi",
  },
  {
    Name: "Sukhadia dhwanil jatinkumar",
    Roll: "19BEC128",
    Personal: "dhwanilsukhadia12@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhwanil-sukhadia/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Swastik handa",
    Roll: "19BEC129",
    Personal: "swastikhanda167@gmail.com",
    Linkedin: "www.linkedin.com/in/swastik-handa-94581420b",
    Company: "E-Infochip",
  },
  {
    Name: "Talavia megi ramesh",
    Roll: "19BEC130",
    Personal: "Mrtalavia@gmail.com",
    Linkedin: "www.linkedin.com/in/megi-talavia-244b1a21a",
    Company: "Lauruss infoways Pvt Ltd",
  },
  {
    Name: "Taneesha chaudhary",
    Roll: "19BEC131",
    Personal: "taneesha1234@gmail.com",
    Linkedin: "www.linkedin.com/in/taneeshachaudhary",
    Company: "E-Infochip",
  },
  {
    Name: "Tanisha mittal",
    Roll: "19BEC132",
    Personal: "MTANISHA1431@GMAIL.COM",
    Linkedin: "https://www.linkedin.com/in/tanisha-mittal-1a5a261b4/",
    Company: "Celebal Technologies",
  },
  {
    Name: "Tejas deshpande",
    Roll: "19BEC133",
    Personal: "deshpandetejas08@gmail.com",
    Linkedin: "https://www.linkedin.com/in/tejas-deshpande-910b18217/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Kanak pragneshkumar tekwani",
    Roll: "19BEC134",
    Personal: "kanaktekwani@gmail.com",
    Linkedin: "https://www.linkedin.com/in/kanak-tekwani",
    Company: "Bosch",
  },
  {
    Name: "Meet dipakbhai thakar",
    Roll: "19BEC135",
    Personal: "meetthakar02@gmail.com",
    Linkedin: "https://www.linkedin.com/in/meet-thakar-643605220",
    Company: "E-Infochip",
  },
  {
    Name: "Krishna chandrakant thakkar ",
    Roll: "19BEC136",
    Personal: "kthakkar.1007@gmail.com",
    Linkedin: "https://www.linkedin.com/in/krishna-thakkar-3899061ab/",
    Company: "E-Infochip",
  },
  {
    Name: "Yash ashokbhai thakkar",
    Roll: "19BEC137",
    Personal: "yashthakkar12342@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yash-thakkar-ab97731ab",
    Company: "E-Infochip",
  },
  {
    Name: "Shreay jayesh upadhyay",
    Roll: "19BEC139",
    Personal: "shreayupadhyay23@gmail.com",
    Linkedin: "www.linkedin.com/in/shreay-upadhyay-b65164190",
    Company: "Encore Research",
  },
  {
    Name: "Upamanyu dixit",
    Roll: "19BEC140",
    Personal: "upamanyudixit@gmail.com",
    Linkedin: "https://www.linkedin.com/in/upamanyu-dixit/",
    Company: "Jekson Vision",
  },
  {
    Name: "Utsav raj goyal",
    Roll: "19BEC141",
    Personal: "utsavrajgoyal40@gmail.com",
    Linkedin: 'https://www.linkedin.com/in/utsav-raj-goyal-473783243/',
    Company: "CSE Solutions",
  },
  {
    Name: "Vaghela saloni vipulbhai",
    Roll: "19BEC142",
    Personal: "salonivaghela437@gmail.com",
    Linkedin: "https://www.linkedin.com/in/saloni-vaghela-87ba3719b",
    Company: "E-Infochip",
  },
  {
    Name: "Vanshika manish gupta",
    Roll: "19BEC143",
    Personal: "guptavanshika0011@gmail.con",
    Linkedin: "linkedin.com/in/vanshika-gupta-2b7ab7209",
    Company: "E-Infochip",
  },
  {
    Name: "Abhi dhiren vora",
    Roll: "19BEC144",
    Personal: "abhiii2301@gmail.com",
    Linkedin: "https://www.linkedin.com/in/abhi-vora-51118322b",
    Company: "E-Infochip",
  },
  {
    Name: "Vora urvil amitkumar ",
    Roll: "19BEC145",
    Personal: "urvilvora109@gmail.com",
    Linkedin: "https://www.linkedin.com/in/urvil-vora-3a7a39162",
    Company: "Jekson Vision",
  },
  {
    Name: "Yash gandhi",
    Roll: "19BEC146",
    Personal: "gandhiyash4939@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yash-gandhi-417b25186",
    Company: "Bharat Sanchar Nigam Limited",
  },
  {
    Name: "Yash jay raval ",
    Roll: "19BEC147",
    Personal: "yashraval5302@gmail.com ",
    Linkedin: " https://www.linkedin.com/in/yash-raval-6b868121b",
    Company: "Oizom",
  },
  {
    Name: "Yashasvi patel ",
    Roll: "19BEC148",
    Personal: "yashasvi2622@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yashasvi-patel-7169aa1b4/",
    Company: "Northern Operating Services Private Limited",
  },
  {
    Name: "Abhishek vijaybhai zinzuvadiya ",
    Roll: "19BEC149",
    Personal: "avsoni6901@gmail.com",
    Linkedin: "https://www.linkedin.com/in/abhishek-zinzuvadiya/",
    Company: "E-Infochip",
  },
  {
    Name: "Devarshi sanjay joshi",
    Roll: "19BEC501",
    Personal: "dev.srjoshi@gmail.com",
    Linkedin: "linkedin.com/in/devarshi-joshi-a326311b0",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Jeet manjit kapadia",
    Roll: "19BEC505",
    Personal: "jeetkapadia113@gmail.com",
    Linkedin: "https://www.linkedin.com/in/jeet-manjit-kapadia-23840a1b9/",
    Company: "Velox Automation",
  },
  {
    Name: "Hetvi khagesh bhatt",
    Roll: "20BEC501",
    Personal: "Hetvibhatt@yahoo.com",
    Linkedin: "/",
    Company: "In-House Project (Nirma University)",
  },
  {
    Name: "Bhagyesh sureshchandra dantkodiya",
    Roll: "20BEC502",
    Personal: "happysdantkodiya@gmail.com",
    Linkedin: "https://in.linkedin.com/in/happy-dantkodiya-7b79481a1",
    Company: "Embee Group",
  },
  {
    Name: "Prit sarjubhai hansaliya",
    Roll: "20BEC503",
    Personal: "hansaliyaprit1213@gmail.com",
    Linkedin: "https://www.linkedin.com/in/prithansaliya/",
    Company: "Elecon Controls",
  },
  {
    Name: "Mansuri ayan",
    Roll: "20BEC504",
    Personal: "ayan762000@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ayan-mansuri-088899221/",
    Company: "infoAnalytica Consulting Pvt Ltd",
  },
  {
    Name: "Nisarg dipakbhai vyas",
    Roll: "20BEC505",
    Personal: "nisargdvyas@gmail.com",
    Linkedin: "https://www.linkedin.com/in/nisarg-vyas-1369a0237/",
    Company: "Stream Line Controls",
  },
  {
    Name: "Dhyey piyush padia",
    Roll: "20BEC506",
    Personal: "dhyey.padia1242@gmail.com",
    Linkedin: "http://linkedin.com/in/dhyey-padia-6389b7241",
    Company: "Aavolate Technologies Pvt. Ltd.",
  },
  {
    Name: "Om chetanbhai prajapati",
    Roll: "20BEC507",
    Personal: "omprajapati1011@gmail.com",
    Linkedin: "https://www.linkedin.com/in/om-prajapati-28a1b1135",
    Company: "Stream Line Controls",
  },
  {
    Name: "Safvan i mansuri",
    Roll: "20BEC508",
    Personal: "safvanmansuri77@gmail.com",
    Linkedin: "https://www.linkedin.com/in/safvan-mansuri-815a83184/",
    Company: "Stream Line Controls",
  },
  {
    Name: "Yash anilbhai sanghani",
    Roll: "20BEC509",
    Personal: "yaspatel7016@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yash-sanghani-3b1b60220",
    Company: "Stream Line Controls",
  },
  {
    Name: "Heet ankur shah",
    Roll: "20BEC511",
    Personal: "heets42@gmail.com",
    Linkedin: "www.linkedin.com/in/heet-shah4",
    Company: "Jekson Vision",
  },
  {
    Name: "Vaykar shivam santoshbhai",
    Roll: "20BEC512",
    Personal: "shivamvaykar704@gmail.com",
    Linkedin: "shivam vaykar",
    Company: "MATRIX COMSECS",
  },
];

export default spdata2023;
